import React from "react";
import { useNavigate } from "react-router-dom";
import { HelpItem } from "../../../../../Axios/services/help.service";
import { getTypeIcon, getTypeColor, extractFileName, openHelpItem } from "../../utils/helpUtils";
import { openLink } from "../../../../content/Globals/globals";
import { Download } from "lucide-react";
import styles from "./HelpCard.module.scss";

interface HelpCardProps {
  item: HelpItem;
}

const HelpCard: React.FC<HelpCardProps> = ({ item }) => {
  const navigate = useNavigate();
  
  const handleCardClick = () => {
    openHelpItem(item, navigate);
  };

  const handleDownload = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent card click when downloading
    if (item.URL__c) {
      openLink(item.URL__c, e);
    }
  };

  return (
    <div className={styles.helpCard} onClick={handleCardClick}>
      <div className={styles.cardHeader}>
        <div 
          className={styles.typeIcon}
          style={{ color: getTypeColor(item.Type__c) }}
        >
          {getTypeIcon(item.Type__c)}
        </div>
        <div 
          className={styles.typeLabel}
          style={{ color: getTypeColor(item.Type__c) }}
        >
          {item.Type__c}
        </div>
      </div>
      
      <div className={styles.cardBody}>
        <h3 className={styles.cardTitle}>{item.Title__c}</h3>
        {item.Description__c && (
          <p className={styles.cardDescription}>
            {item.Description__c}
          </p>
        )}
      </div>
      
      {item.URL__c && (
        <div className={styles.cardFooter}>
          <span 
            className={styles.downloadText}
            onClick={handleDownload}
            title={`Download ${extractFileName(item.URL__c)}`}
          >
            <Download size={16} />
            {extractFileName(item.URL__c)}
          </span>
        </div>
      )}
    </div>
  );
};

export default HelpCard;